<script setup lang="ts"></script>

<template>
  <p
    class="font-secondary border-b-2 border-solid border-white text-center text-M-22 me-M-30 ms-M-30 mb-M-30 mt-M-50 md:border-b-[.5px] md:mt-D-30 md:text-D-62 md:mb-D-70 md:me-D-182 md:ms-D-182"
  >
    {{ $t("catalog.id.title") }}
  </p>
</template>
